import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Grid } from "../core/components/grid";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";

export default class EditTranslations extends React.Component<EditTranslationsProps, EditTranslationsState> {
    private gridOptions: kendo.ui.GridOptions;
    private gridId: string;
    private selected: number;
    private dataChanged: boolean;
    private invisibleLanguages: number[] = [];
    private gridRef: HTMLDivElement;
    constructor(props) {
        super(props);
        this.gridId = kendo.guid();
        if (Helper.hasValue(props.field.invisibleLanguages)) {
            this.invisibleLanguages = props.field.invisibleLanguages;
        }
        this.selected = null;
        this.dataChanged = false;
        this.initApp();
        this.state = {
            gridData: []
        }
    }

    private update = () => {
        this.dataChanged = true;
        let values = this.props.value;
        let index: number;
        for (let i = 0; i < this.state.gridData.length; i++) {
            index = values.findIndex(f => f.Key == this.state.gridData[i].Key);
            if (index > -1) {
                values[index].Value = this.state.gridData[i].Value;
            } else {
                values.push({ Key: this.state.gridData[i].Key, Value: this.state.gridData[i].Value });
            }
        }
        this.props.onChange(this.props.field, values);
    }

    private onKeyUp = (e: JQuery.KeyUpEvent) => {
        if (Helper.hasValue(this.selected)) {
            const enter = 13;
            //const arrowLeft = 37;
            const arrowUp = 38;
            //const arrowRight = 39;
            const arrowDown = 40;
            const tab = 9;
            const keyCode = e.keyCode;


            let index = -1;
            switch (keyCode) {
                case enter:
                case arrowDown:
                case tab:
                    index = this.selected + 1;
                    break;
                case arrowUp:
                    index = this.selected - 1;
                    break;
            }
            if (keyCode === arrowDown || keyCode === arrowUp || keyCode == tab) {
                this.keepValueOfSelectedElement();
                this.moveWithTimeout(index, 10);
            } else if (keyCode === enter) {
                this.moveWithTimeout(index, 10);
            }
        }
    }

    private moveWithTimeout = (index: number, timeout: number = 0) => {
        setTimeout(() => {
            this.move(index)
        }, timeout)
    }

    private move = (index: number) => {
        let focused = $("#" + this.gridId + " :focus");
        let editableCells = $("#" + this.gridId + " tr td:nth-child(2)");
        if (index === -1) {
            index = editableCells.length - 1;
        }
        if (index === editableCells.length) {
            index = 0;
        }
        if (Helper.hasValue(editableCells) && (index > -1) && (index < editableCells.length) && ((focused.length > 0) || this.dataChanged)) {
            this.dataChanged = false;
            let el = editableCells[index];
            el.click();
        }
    }

    private keepValueOfSelectedElement = () => {
        let $focused = $(':focus')
        if (Helper.hasValue($focused)) {
            let gridData = this.state.gridData;
            let value = $focused.val();
            if (Helper.hasValue(value)) {
                gridData[this.selected].Value = value.toString();
                this.setState({ gridData: gridData }, this.update);
            }
        }
    }

    private initApp = async () => {
        $(document).bind("keyup", this.onKeyUp);
        this.gridOptions = {
            dataSource: {
                schema: {
                    model: {
                        id: "Id",
                        fields: {
                            Language: { editable: false },
                            Value: { editable: !this.props.disabled }
                        }
                    }
                }
            },
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: true,
            save: (e: kendo.ui.GridSaveEvent) => {
                let item = (e.model) as any;
                item.Value = e.values["Value"];
                this.onGridValueChange(item);
            },
            columns: [
                {
                    field: "Language",
                    title: Helper.getTranslation("Field.Adresse.language")
                },
                {
                    field: "Value",
                    title: Helper.isNullOrEmpty(this.props.field.columnName) ? Helper.getTranslation("Standard.Value") : this.props.field.columnName,
                    editable: (data) => {
                        this.selected = this.state.gridData.findIndex(f => f.Key == data["Key"]);
                        return true;
                    }
                }
            ]
        };
        const result = await HTTPService.get<JsonResultClass<any[]>>("EditIndividualFields/GetLanguages");
        if (result.Code === 0) {
            let data: GridData[] = result.Data.map((item) => {
                let v = this.props.value.find(f => f.Key === item.Id);
                let value: string = null;
                if (Helper.hasValue(v)) {
                    value = v.Value;
                }
                return {
                    Key: item.Id,
                    Value: value,
                    Language: item.Displaynameen + " (" + item.Displaynamenative + ")"
                };
            })
            this.setState({ gridData: data })
        }
    }

    private createGrid = () => {
        const data = this.state.gridData.filter(item => this.invisibleLanguages.findIndex(l => item.Key == l) == -1);
        return (
            <div className="flex-container" id={this.gridId} ref={(ref) => { this.gridRef = ref }} >
                <style>
                    {
                        `.k-input-solid, .k-input-solid:focus-within {
                            background-color: white;
                        }`
                    }
                </style>
                <Grid
                    data={data}
                    options={this.gridOptions}
                    id="individualFieldTranslations"
                />
            </div>
        );
    }

    private onGridValueChange = (dataItem: GridData) => {
        let index = this.state.gridData.findIndex(f => f.Key === dataItem.Key);
        let gridData = this.state.gridData;
        gridData[index].Value = dataItem.Value;
        if (Helper.hasValue(this.props.field.maxLenght) && Helper.isNumber(this.props.field.maxLenght) && this.props.field.maxLenght > 0)
            gridData[index].Value = gridData[index].Value.substr(0, this.props.field.maxLenght);
        this.setState({ gridData: gridData }, this.update)
    }

    componentWillUnmount() {
        $(document).unbind("keyup", this.onKeyUp);
    }

    componentDidMount() {
        if (this.gridRef) {
            this.gridRef.addEventListener('keydown', (e) => {
                if (e.keyCode == 9 && Helper.hasValue(this.selected)) {
                    e.preventDefault();
                }
            })
        }
    }

    render() {
        return this.createGrid()
    }
}

export interface EditTranslationsProps {
    value: KeyValuePair<number, string>[];
    onChange: (field, value) => void;
    field: any;
    disabled: boolean;
    context: {
        translations?: any
    }
}

interface EditTranslationsState {
    gridData: GridData[];
}

interface GridData {
    Key: number;
    Value: string;
    Language: string;
}